module.exports = __webpack_public_path__ + "img/ripple-texture-about-low.b4325245.jpg";